import Images from "../asset";
import React, { useEffect, useState } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
export default function SidebarMenu() {
  const navigate = useNavigate();
  const userData = sessionStorage.getItem("userdata");
  const location = useLocation(); // Get current route
  const [activeItem, setActiveItem] = useState(location.pathname);
  console.log("activeItem", activeItem);
  useEffect(() => {
    setActiveItem(location.pathname); // Update active item on route change
  }, [location.pathname]);

  return (
    <div>
      <Sidebar style={{ width: "100%", zIndex: 0 }}>
        <Menu style={{ backgroundColor: "#D9D9D9", height: "100vh" }}>
          <div className="d-flex justify-content-center py-2">
            <img
              src={Images?.loginlogoIcon}
              alt="logo"
              style={{
                width: "auto",
                height: "auto",
                borderRadius: "10px",
                padding: "0px",
              }}
            />
          </div>

          {/* Visitors Information */}
          <SubMenu
            className="sideBarMenuItem"
            label="Visitors Information"
            defaultOpen
          >
            <MenuItem
              component={<Link to="/visitorEntry" />}
              className={`sideBarMenuItem ${
                activeItem === "/visitorEntry" ? "active-menu" : ""
              }`}
              onClick={() => setActiveItem("/visitorEntry")}
            >
              Visitor Entry
            </MenuItem>
            <MenuItem
              component={<Link to="/" />}
              className={`sideBarMenuItem ${
                activeItem === "/" ? "active-menu" : ""
              }`}
              onClick={() => setActiveItem("/")}
            >
              Visitors
            </MenuItem>
          </SubMenu>

          {/* Clients Information */}
          <SubMenu
            className="sideBarMenuItem"
            label="Clients Information"
            defaultOpen
          >
            <MenuItem
              component={<Link to="/clientEntry" />}
              className={`sideBarMenuItem ${
                activeItem === "/clientEntry" ? "active-menu" : ""
              }`}
              onClick={() => setActiveItem("/clientEntry")}
            >
              Client Entry
            </MenuItem>
            <MenuItem
              component={<Link to="/clientList" />}
              className={`sideBarMenuItem ${
                activeItem === "/clientList" ? "active-menu" : ""
              }`}
              onClick={() => setActiveItem("/clientList")}
            >
              Clients & Subject
            </MenuItem>
          </SubMenu>

          {/* Other Menu Items */}
          {/* {userData === "superAdmin" && ( */}
          <MenuItem
            component={<Link to="/filterData" />}
            className={`sideBarMenuItem ${
              activeItem === "/filterData" ? "active-menu" : ""
            }`}
            onClick={() => setActiveItem("/filterData")}
          >
            Search Box
          </MenuItem>
          {/* )} */}
          {userData === "superAdmin" && (
            <MenuItem
              component={<Link to="/fileUpload" />}
              className={`sideBarMenuItem ${
                activeItem === "/fileUpload" ? "active-menu" : ""
              }`}
              onClick={() => setActiveItem("/fileUpload")}
            >
              File Upload
            </MenuItem>
          )}

          {/* Super Admin Menu */}
          {userData === "superAdmin" && (
            <SubMenu className="sideBarMenuItem" label="User Management">
              <MenuItem
                component={<Link to="/viewRegister" />}
                className={`sideBarMenuItem ${
                  activeItem === "/viewRegister" ? "active-menu" : ""
                }`}
                onClick={() => setActiveItem("/viewRegister")}
              >
                Existing User
              </MenuItem>
              <MenuItem
                component={<Link to="/userRegister" />}
                className={`sideBarMenuItem ${
                  activeItem === "/userRegister" ? "active-menu" : ""
                }`}
                onClick={() => setActiveItem("/userRegister")}
              >
                Add New User
              </MenuItem>
            </SubMenu>
          )}

          <MenuItem
            onClick={() => {
              // Clear all session-based data
              sessionStorage.clear();

              // ⚠️ Do NOT clear everything from localStorage
              // Instead, remove only login-related items
              localStorage.removeItem("login");
              localStorage.removeItem("userdata");
              localStorage.clear();
              // keep "popupVerified" safe

              // Navigate to login page
              navigate("/");

              // Optional: only reload if absolutely necessary
              window.location.reload();
            }}
            className="fw-bold fs-5 sidebarListName"
          >
            Logout
          </MenuItem>

          {/* <MenuItem
            onClick={() => {
              sessionStorage.clear();
              localStorage.clear();
              navigate("/");
              window.location.reload();
            }}
            className="fw-bold fs-5 sidebarListName"
          >
            Logout
          </MenuItem> */}
          <MenuItem
            onClick={() => {
              navigate(-1);
            }}
            // style={{backgroundColor:"#3c30bb",color:"white"}}
            className="fw-bold sideBarMenuItem text-end"
          >
            Back
          </MenuItem>
        </Menu>
      </Sidebar>
    </div>
  );
}
